import { makeAutoObservable } from 'mobx';

import type { ICatalogCategory, Nullable } from '@shared/types';

export const CATALOG_CATEGORIES: ICatalogCategory[] = [
  {
    id: '1',
    slug: 'smart-playground',
    title: 'Умная спортивная площадка',
    sub: 'по приказу Минспорта',
    coverImage: '/equipment/smart-playground/Ограждение+воркаут.webp',
  },
  {
    id: '2',
    slug: 'sport-platforms',
    title: 'Спортивные площадки',
    sub: 'для физической подготовки',
    coverImage: '/equipment/sport-platforms/Спортивная площадка.webp',
  },
  {
    id: '3',
    slug: 'metal-structures',
    title: 'Металлоконструкции',
    sub: 'на заказ',
    isComingSoon: true,
  },
  {
    id: '4',
    slug: 'spectator-stands',
    title: 'Зрительские трибуны',
    sub: 'сборно-разборные',
    isComingSoon: true,
  },
  { id: '5', slug: 'workout-platforms', title: 'Воркаут площадки', isComingSoon: true },
  {
    id: '6',
    slug: 'trainers',
    title: 'Тренажёры',
    coverImage: '/equipment/trainers/01. Жим лежа.webp',
  },
];

class CatalogStore {
  categories: ICatalogCategory[] = CATALOG_CATEGORIES;
  activeItemId: Nullable<string> = null;

  constructor() {
    makeAutoObservable(this);
  }

  setActiveItem = (id: Nullable<string>): void => {
    this.activeItemId = id;
  };
}

export const catalogStore = new CatalogStore();
